import { $toast } from "vuetify-snackbar-toast";

import store from "@/store";
import authService from "../../Services/AuthService";

const semPermissaoFundeb = async (to, from, next) => {
  let currentUser = store.getters["Auth/user"];

  if (!currentUser) {
    await authService.syncUserWithStore();
    currentUser = store.getters["Auth/user"];
  }

  if (
    currentUser.roleName !== "super-admin" &&
    currentUser.roleName !== "admin" &&
    currentUser.roleName !== "coordenador-semed"
  ) {
    return next({ name: "home" });
  }

  return next();
};

export default semPermissaoFundeb;
